import { render, staticRenderFns } from "./ReportBlock.vue?vue&type=template&id=34db290c&scoped=true"
import script from "./ReportBlock.vue?vue&type=script&lang=js"
export * from "./ReportBlock.vue?vue&type=script&lang=js"
import style0 from "./ReportBlock.vue?vue&type=style&index=0&id=34db290c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34db290c",
  null
  
)

export default component.exports